import { useEffect, useState } from 'react'
import './loadingBox.css'

interface LoadingBoxProps {
  loading: boolean
}

export const LoadingBox = ({ loading }: LoadingBoxProps) => {
  const [shouldRender, setShouldRender] = useState(false)
  const [fadeIn, setFadeIn] = useState(false)

  useEffect(() => {
    if (loading) {
      setShouldRender(true)
      setTimeout(() => setFadeIn(true), 10)
    } else {
      setFadeIn(false)
      const timeout = setTimeout(() => setShouldRender(false), 500)
      return () => clearTimeout(timeout)
    }
  }, [loading])

  return shouldRender ?
      <div className={`loading_box ${fadeIn ? 'show' : ''}`}>
        <div className="loading_box_container">
          <div className="content_box-row">
            <div className="content_box content_box1"></div>
            <div className="content_box content_box2"></div>
          </div>
          <div className="content_box-row">
            <div className="content_box content_box4"></div>
            <div className="content_box content_box3"></div>
          </div>
        </div>
      </div>
    : null
}
